/* @flow */

import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';

import RadioMenu from 'shared/components/RadioMenu';

import {
  DEFAULT_ACTION_TYPE,
  INAPP_ACTION,
  NAVIGATOR_ACTION,
} from './constants';

type Props = {
  block: EditorialLinkBlock,
  onSerialize?: (block: EditorialMapBlock) => void,
  onCanSubmitChanged?: (value: boolean) => void,
};

class Edit extends Component {
  props: Props;

  handleUrlChange = (evt: SyntheticEvent) => {
    if (evt.target instanceof HTMLInputElement) {
      const { block, onSerialize, onCanSubmitChanged } = this.props;

      const validUrl = !evt.target.value.match(/^[a-zA-Z]+:\/\//)
        ? 'http://' + evt.target.value
        : evt.target.value;

      onSerialize({ ...block, url: validUrl });
      onCanSubmitChanged(validUrl && true);
    }
  };

  handleTitleChange = (evt: SyntheticEvent) => {
    if (evt.target instanceof HTMLInputElement) {
      const { block, onSerialize } = this.props;

      onSerialize({ ...block, content: evt.target.value });
    }
  };

  toggleInApp = (evt: SyntheticEvent) => {
    evt.preventDefault();
    if (evt.target instanceof HTMLButtonElement) {
      const { block, onSerialize } = this.props;

      onSerialize({ ...block, action: INAPP_ACTION });
    }
  };

  toggleNavigator = (evt: SyntheticEvent) => {
    evt.preventDefault();
    if (evt.target instanceof HTMLButtonElement) {
      const { block, onSerialize } = this.props;

      onSerialize({ ...block, action: NAVIGATOR_ACTION });
    }
  };

  componentDidMount() {
    const { block, onSerialize, onCanSubmitChanged } = this.props;

    if (!block.action) {
      onSerialize({ ...block, action: DEFAULT_ACTION_TYPE });
    }
    onCanSubmitChanged(block.url && true);
  }

  render() {
    const { block } = this.props;

    const menuDescriptor = [
      { value: INAPP_ACTION, handler: this.toggleInApp, label: 'InApp' },
      {
        value: NAVIGATOR_ACTION,
        handler: this.toggleNavigator,
        label: 'Navigateur',
      },
    ];

    return (
      <Form>
        <Form.Input
          label="Destination"
          defaultValue={block.url}
          onChange={this.handleUrlChange}
          required
        />
        <Form.Field>
          <label>Titre</label>
          <Form.Input
            defaultValue={block.content}
            onChange={this.handleTitleChange}
          />
        </Form.Field>
        <Form.Field>
          <label>Type d'action</label>
          <RadioMenu currentValue={block.action} menuDesc={menuDescriptor} />
        </Form.Field>
      </Form>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/link/Edit.js